const React = window.React;
import PropTypes from 'prop-types';

import Attempt from './attempt';

class Cemantix extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      inputValue: "",
      value: props.value,
      lastValue: props.lastValue,
      loading: false,
      state: props.state,
      winners: props.winners
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onInputValueChange = this.onInputValueChange.bind(this);
    this.reveal = this.reveal.bind(this);
  }

  componentDidMount = () => {
    const { readOnly } = this.props;

    window.addEventListener('turbolinks:load', () => {
      window.removeEventListener('keydown', this.handleKeyBinding);
    }, { once: true });

    if (!readOnly) window.addEventListener('keydown', this.handleKeyBinding);

    window.addEventListener('new_word', this.handleNewWord);

    if (location.pathname != this.props.endpoint) {
      window.history.replaceState(
        undefined,
        document.title,
        this.props.endpoint,
      );
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('keydown', this.handleKeyBinding);
    window.removeEventListener('new_word', this.handleNewWord);
  }

  handleKeyBinding = event => {
    if (document.querySelector('.js-sign-in-modal')) return;
    if (document.activeElement == this.input) return;
    if (this.state.state == 'win') return;

    if (this.isEnter(event)) this.submitAttempt();
  }

  handleNewWord = event => {
    const word = event.detail.word;

    if (this.state.inputValue != word && (!this.state.lastValue || this.state.lastValue[0] != word) && !this.state.value.map(value => value[0]).includes(word)) this.getValue(word);
  }

  isEnter(event) {
    const charCode = event.keyCode;
    return charCode == 13;
  }

  triggerWarning(msg = "") {
    if (msg) FLASH.warning(msg);
    this.setState(prevState => {
      this.input.classList.add('animate-shake');
      return prevState;
    }, () => {
      setTimeout(() => {
        this.setState(prevState => {
          this.input.classList.remove('animate-shake');
          return prevState;
        });
      }, 400);
    });
  }

  isLoading() {
    const { loading } = this.state;
    return loading;
  }

  onSubmit(e) {
    e.preventDefault();

    this.submitAttempt();
  }

  getValue(word = null) {
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    this.setState({ loading: true });

    fetch(word ? `${this.props.endpoint}?word=${word}` : this.props.endpoint, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': token
      },
      credentials: 'same-origin'
    }).then(response => response.json())
      .then(data => {
        if (data.url) { // Redirect to new Cemantix
          window.location.replace(data.url);
          return;
        }

        if (data.result && data.result[2] == 0) {
          this.setState({
            winners: data.winners
          });
        } else {
          this.displayNewValue(data);
        }
      });
  }

  submitAttempt() {
    this.scrollToTop();

    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    if(!this.isLoading()) {
      const { inputValue } = this.state;

      this.setState({ loading: true });

      fetch(this.props.endpoint, {
        method: 'PUT',
        body: JSON.stringify({
          value: inputValue.trim()
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': token
        },
        credentials: 'same-origin'
      }).then(response => response.json())
        .then(data => {
          if (data.url) { // Redirect to new Cemantix
            window.location.replace(data.url);
            return;
          }

          if (Object.keys(data).length === 0) {
            this.setState({ loading: false, inputValue: '' }, () => {
              this.triggerWarning(`Ce mot n'est pas valide`);
            });
            return;
          }

          this.displayNewValue(data, () => {
            fetch(this.props.endpoint, {
              headers: {
                'Accept': 'text/javascript',
                'Content-Type': 'text/javascript',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': token
              },
              credentials: 'same-origin'
            }).then(response => response.text())
              .then(data => eval(data));
          });
        }).catch(error => {
          window.location.reload();
        });
    }
  }

  displayNewValue(data, callback = () => {}) {
    const ranked = data.result && data.result[2] != null;

    this.setState(prevState => ({
      inputValue: '',
      lastValue: data.result ? data.result : prevState.lastValue,
      animate: data.result ? ranked : true
    }), () => {
      window.site.twemoji.init();

      if (data.state == 'retry') {
        // Wait for attempt animate-reveal completion
        setTimeout(() => {
          this.setState({
            loading: false,
            animate: false,
            value: data.value,
            state: data.state,
            winners: data.winners
          }, () => {
            window.site.twemoji.init();
          });
        }, ranked ? 1500 : 0);
      } else {
        setTimeout(() => {
          this.setState({
            loading: false,
            animate: false,
            state: data.state,
            winners: data.winners
          }, () => {
            window.site.twemoji.init();
          });
        }, 1500);

        callback();
      }
    });
  }

  onInputValueChange(event) {
    this.setState({
      inputValue: event.target.value
    })
  }

  orderedValue(value = this.state.value) {
    return value.map((item, index) => [index + 1].concat(item)).sort((a, b) => b[2] - a[2]);
  }

  indexOfLastValue() {
    const { lastValue } = this.state;

    if (!lastValue) return;

    const orderedValue = this.orderedValue();
    const item = orderedValue.find(item => item[1] == lastValue[0]);

    return item ? item[0] : orderedValue.length + 1;
  }

  reveal() {
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    this.setState({ loading: true });

    fetch(`${this.props.endpoint}?reveal=true`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': token
      },
      credentials: 'same-origin'
    }).then(response => response.json())
      .then(data => {
        this.setState({
          inputValue: data.word,
          loading: false
        })
      });
  }

  scrollToTop = () => {
    const y = this.inputRef.getBoundingClientRect().top + window.scrollY - 10;
    window.scroll({
      top: y,
      behavior: 'smooth'
    });
  }

  render() {
    const { legend, blured } = this.props;
    const { value, inputValue, lastValue, animate, state, winners } = this.state;
    const orderedValue = this.orderedValue();
    const lastValueIsTheBest = lastValue && orderedValue.length && lastValue[0] == orderedValue[0][1];

    const first_winners = winners.slice(0, winners.length - 1);
    const last_winner = winners[winners.length - 1];
    const winners_list = winners.length > 1 ? (`<span class="font-semibold">${first_winners.join('</span>, <span class="font-semibold">')}</span> et <span class="font-semibold">${last_winner}</span>`) : `<span class="font-semibold">${winners[0]}</span>`;

    return (
      <div className={blured ? 'filter-blur' : ''}>
        { (!state || state == "retry") && (
          <div>
            { winners.length ? (
              <div className="mb-2">
                <div className="p-4 bg-warning-light shadow rounded">
                  <div className="flex items-start">
                    <div className="mr-3"><span className="inline-block w-5">🏆</span></div>
                    <div>
                      <p>{winners.length > 1 ? 'Les joueurs suivants ont ' : 'Le joueur suivant a'} trouvé le mot : <span dangerouslySetInnerHTML={{__html: winners_list}} />.</p>
                      <button type="button" className="bg-white text-black text-base py-1 px-2 rounded-md inline-block align-middle mt-2" onClick={this.reveal}>
                        Révéler le mot
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null }
            <form onSubmit={this.onSubmit} className="flex items-center flex-col md:flex-row" ref={(ref) => { this.inputRef = ref }}>
              <input className="w-full border border-grey-light shadow" style={{ backgroundColor: 'white' }} placeholder="Tapez un mot" onChange={this.onInputValueChange} autoFocus value={inputValue} ref={(element) => { this.input = element; }} />
              <button className="bg-success text-white py-1 px-2 text-base font-semibold rounded-md inline-block align-middle mt-2 w-full md:w-auto md:mt-0 md:ml-2" style={{ paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', display: 'block', fontSize: '1.125rem' }}>
                Soumettre
              </button>
            </form>
            { value.length >= 10 && (
              <a href="#indices" className="bg-danger bg-opacity-20 text-black text-opacity-80 py-1 px-2 text-lg font-bold rounded-md inline-block align-middle mt-2 md:mt-3 w-full" style={{ paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', display: 'block' }}>
                <span className="animate-shake-infinite w-6 inline-block mr-1 -ml-1">🆘</span> Besoin d'aide ?
              </a>
            ) }
          </div>
        ) }

        <div>
          <h5 className="text-xl sm:text-2xl font-bold mt-6 flex items-center md:h-12" id="resultat">
            Résultats
          </h5>
          <table className="w-full">
            <thead className="border-b border-grey-light">
              <tr>
                <th className="text-left py-2 px-3" style={{ width: '38px' }}>N°</th>
                <th className="text-left py-2">Mot</th>
                <th className="text-right py-2 pr-4" style={{ width: '60px' }}><span>°C</span></th>
                <th className="text-left py-2" style={{ minWidth: '36px', width: '36px' }}>🌡️</th>
                <th className="text-left py-2 pr-3" style={{ maxWidth: '35%' }}>Proximité</th>
              </tr>
            </thead>
            <tbody>
              {
                lastValue && (
                  <Attempt key={lastValue[0]} legend={legend} value={[this.indexOfLastValue()].concat(lastValue)} highlight animate={animate} className="border-b-2 border-white" />
                )
              }
              {
                (lastValueIsTheBest ? orderedValue.slice(1) : orderedValue).map(
                  (item, index) => {
                    return (
                      <Attempt legend={legend} key={item[1]} value={item} index={index + 1} highlight={lastValue && item[1] === lastValue[0]} />
                    )
                  }
                )
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

Cemantix.propTypes = {
  state: PropTypes.string,
  legend: PropTypes.array,
  winners: PropTypes.array,
  endpoint: PropTypes.string,
  value: PropTypes.array,
  readOnly: PropTypes.bool,
  blured: PropTypes.bool
};

Cemantix.defaultProps = {
  value: [],
  winners: [],
  readOnly: false,
  blured: false
};

export default Cemantix;
